<template>
  <div class="content">
    <h1 class="content__title">Lista de Entradas</h1>
    <span class="content__details">Listado de entradas, crea entradas</span>
    <div class="content__container">
      <main class="main">
        <section class="main__section">
          <h2 class="main__title">Lista de Entradas</h2>
          <div class="main__results">
            <div class="result" v-if="posts === 'loading'">
              <div class="result__data">
                <img class="result__loading" src="/static/img/waiting.gif" alt="Cargando información">
              </div>
            </div>
            <div class="result" v-else-if="!posts">
              <div class="result__data">
                <h2 class="result__title">No se encontraron resultados</h2>
              </div>
            </div>
            <div class="result" v-else v-for="(post, index) in posts" :key="index">
              <div class="result__data">
                <h2 class="result__title" v-text="'Nombre: ' + post.title_es"></h2>
                <p class="result__detail" v-text="'Categoría: ' + post.category_name"></p>
              </div>
              <div class="result__options">
                <router-link class="btn btn__default btn--small" :to="{name: 'postEdit', params: {id: post.id}}" > Editar</router-link>
                <button class="btn btn__caution btn--small" @click="deletePost(post.id)">Borrar</button>
              </div>
            </div>

          </div>
          <pagination v-if="pagination.pages !== null" :config="pagination"></pagination>
        </section>
      </main>
      <aside class="sidebar">
        <h2 class="sidebar__title">NAVEGACIÓN</h2>
        <router-link class="btn btn--small btn__default" :to="{name: 'postNew'}">Nueva Entrada</router-link>
        <h2 class="sidebar__title">OPCIONES</h2>
        <router-link class="btn btn--small btn__default" :to="{name: 'postCategoryList'}">Categorías</router-link>
        <router-link class="btn btn--small btn__default" :to="{name: 'postCategoryNew'}">Nueva Categoría</router-link>
      </aside>
    </div>
    <confirmation v-if="confirm" @cancel="confirm = false"></confirmation>
  </div>
</template>

<script>
import httpService from '@/api/request'
import pagination from '@/components/layout/pagination'
import confirmation from '@/components/layout/confirmation'
export default {
  mixins: [httpService],
  components: {
    pagination,
    confirmation
  },
  data: function () {
    return {
      posts: 'loading',
      confirm: false,
      pagination: {
        maxButtons: 8,
        results: null,
        pages: null
      },
      maxResults: 12,
      page: 1,
      id: null
    }
  },
  created: function () {
    this.page = this.$route.params.page
    this.getPosts()
  },
  mounted: function () {
    this.$on('continue', () => {
      this.confirm = false
      this.proccedToDelete()
    })
  },
  watch: {
    '$route.path': function () {
      this.page = this.$route.params.page
      this.getPosts()
    }
  },
  methods: {
    deletePost: function (id) {
      this.confirm = true
      this.id = id
    },
    proccedToDelete: function () {
      let httpRequest = {
        module: 'posts'
      }
      this.delete(this.id, httpRequest)
        .then(
          () => {
            this.getPosts()
            this.$store.commit('notificate', {
              title: 'ENTRADA BORRADA',
              text: 'La Entrada ha sido borrada correctamente.',
              type: 'success'
            })
          }
        )
    },
    getPosts: function () {
      let httpRequest = {
        module: 'posts',
        params: '?fields=title_es,id,category_name&limit=' + this.maxResults + '&page=' + this.page + '&embed=pagination'
      }
      this.get(httpRequest)
        .then(
          posts => {
            this.posts = posts.data
            this.pagination.pages = posts.pagination.pages
            this.pagination.currentPage = posts.pagination.current_page
            this.pagination.results = posts.pagination.results
          }
        )
        .catch(
          () => {
            this.posts = null
            this.pagination.pages = null
            this.pagination.currentPage = null
            this.pagination.results = null
            if (this.page > 1) {
              this.$router.push({name: 'postList', params: {page: this.page - 1}})
            }
          }
        )
    }
  }
}
</script>

<style lang="sass" scoped>
@import "../../assets/sass/objects/_btns"
@import "../../assets/sass/components/layout/_forms"
</style>


// WEBPACK FOOTER //
// src/components/posts/list.vue